import { useState, useEffect } from "react";
import axios from "axios";
import { generateEndpoint } from "utils/helpers/generateEndpoint";

const useFetchStripeTransaction = (paymentIntentId) => {
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [data, setData] = useState(null);

  useEffect(() => {
    const fetchPaymentIntentDetails = async () => {
      try {
        const endpoint = generateEndpoint(
          process.env.REACT_APP_AWS_DEV_POST_STRIPE_FETCH_TRANSACTION_ENDPOINT,
          process.env.REACT_APP_AWS_PROD_POST_STRIPE_FETCH_TRANSACTION_ENDPOINT
        );
        const response = await axios.post(endpoint, {
          paymentIntentId,
        });

        setData(response.data.paymentIntent);
      } catch (error) {
        setError(error.response?.data?.error || error.message);
      } finally {
        setLoading(false);
      }
    };

    if (paymentIntentId) {
      fetchPaymentIntentDetails();
    }
  }, []);

  return { loading, error, data };
};

export default useFetchStripeTransaction;
